import React from 'react';
import { SectionLabel, SectionHeading } from './ui/UI';
export function About() {
  return <section id="about" className="relative w-full py-32 border-t border-white/5" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-60">
        <SectionLabel number="21" label="About" className="mb-8" data-id="element-61" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-62">
          <div className="lg:col-span-5" data-id="element-63">
            <SectionHeading size="xl" data-id="element-64">
              Reborn in 2026
              <br data-id="element-65" />
              <span className="text-white/40" data-id="element-66">by its original founder.</span>
            </SectionHeading>
          </div>

          <div className="lg:col-span-7 space-y-6 text-lg text-white/70 leading-relaxed" data-id="element-67">
            <p data-id="element-68">
              Periscan is being reborn in 2026 by its original founder,{' '}
              <span className="text-white font-medium" data-id="element-69">Sean Heiney</span>.
            </p>
            <p data-id="element-70">
              The original Periscan began in 2004 as an early pioneer in
              automated, continuous security assessment. Before the industry had
              language for external attack surface management, continuous threat
              exposure management, adversarial exposure validation, or
              continuous security validation, Periscan was already focused on
              giving defenders a constant{' '}
              <em className="text-white/90 not-italic" data-id="element-71">hacker's-eye view</em> of
              their networks.
            </p>
            <p data-id="element-72">
              After the company was acquired by Catbird Networks, the brand
              eventually went quiet.{' '}
              <span className="text-[#1a8fd4]" data-id="element-73">
                Now the market has caught up.
              </span>
            </p>
            <p data-id="element-74">
              Security validation is moving from periodic testing and noisy
              tools to continuous software. AI makes expert-level security
              reasoning more scalable. Modern teams need evidence they can share
              with customers, auditors, insurers, and executives.
            </p>
            <p className="text-white font-medium pt-4 border-t border-white/5" data-id="element-75">
              Find the path. Fix the risk. Prove it's gone.
            </p>
          </div>
        </div>
      </div>
    </section>;
}